import { type PropsWithChildren, useState } from 'react';

import { createSafeContext } from '@/package';

type RenderFlag = {
  labelingBox: boolean;
  pcd: boolean;
};

export const ToolContext = createSafeContext<{
  renderFlag: RenderFlag;
  setRenderFlag: React.Dispatch<React.SetStateAction<RenderFlag>>;
}>({} as any, 'ToolContext');

export const ToolContextProvider = ({ children }: PropsWithChildren) => {
  const [renderFlag, setRenderFlag] = useState<RenderFlag>({
    labelingBox: false,
    pcd: false,
  });

  return (
    <ToolContext.Provider value={{ renderFlag, setRenderFlag }}>
      {children}
    </ToolContext.Provider>
  );
};
